// extracted by mini-css-extract-plugin
export default {"container":"OrderDashboard_container__ZT9H4","container_outer":"OrderDashboard_container_outer__njTzB","label":"OrderDashboard_label__Elul6"};